<script>
import Layout from "../../layouts/auth";
import axios from "axios";
import {
  authMethods,
  authFackMethods,
} from "@/state/helpers";
import { mapGetters } from "vuex";
import appConfig from "@/app.config";
import {
  required,
  sameAs,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

var CryptoJS = require("crypto-js");
var CryptoJSAesJson = {
  stringify: function(cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function(jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct),
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  },
};
export default {
  page: {
    title: "Reset Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      notMatched: false,
      form: {
        email: "",
        token: "",
        password: "",
        confirmPassword: "",
      },
      showPass: false,
      showConfirmPass: false,
      serverId: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      loader: this.$store ? this.$store.state.layout.loader : {} || {},
      loadingSpinner:false,
    };
  },
  validations: {
    form: {
      token: { required, minLength: minLength(8) },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(20),
        containsUppercase: function(value) {
          return /[A-Z]/.test(value);
        },
        containsLowercase: function(value) {
          return /[a-z]/.test(value);
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value);
        },
        containsSpecial: function(value) {
          return /[#?!@$%^&*-]/.test(value);
        },
      },
      confirmPassword: {
        sameAsPassword: sameAs("password"),
        required,
      },
    },
  },
  computed: {
    ...mapGetters("authfack", ["loadingStatus"]),
    disableBtn() {
      return (
        (this.form.token&&this.form.token.length > 0) &&
        this.form.password.length > 0 &&
        this.form.confirmPassword.length == this.form.password.length
      );
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    resetPassword() {
      this.submitted = true;
      this.$v.$touch();
      if (!this.$v.form.confirmPassword.sameAsPassword) this.notMatched = true;
      if (!this.$v.$invalid) {
        this.loadingSpinner = true;
        let encryptedPassword = btoa(
          CryptoJS.AES.encrypt(
            JSON.stringify(this.form.password),
            this.serverId,
            { format: CryptoJSAesJson }
          ).toString()
        );
        let params = {
          email: this.form.email,
          token: this.form.token,
          password: encryptedPassword,
        };
        axios
          .post(`${process.env.VUE_APP_BASE_URL}/api/password-reset`, params)
          .then((data) => {
            this.loadingSpinner = false
            this.$toast.success(data.data.message);
            this.$router.replace("/login");
          })
          .catch((error) => {
            this.loadingSpinner = false
            this.$toast.error(error.response.data.message);
          });
      }
    },
    onShowPassword() {
      this.showPass = !this.showPass;
    },
    onShowConfirmPassword() {
      this.showConfirmPass = !this.showConfirmPass;
    },
  },
  beforeMount() {
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/api/server-details`)
      .then((data) => {
        localStorage.setItem("serverId", data.data.data);
        this.serverId = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.form.email = this.$route.params.email?this.$route.params.email:"";
    this.form.token = this.$route.params.token?this.$route.params.token:null;
  },
};
</script>

<template>
  <Layout>
    <section class="wrapper">
      <div class="content">
        <div class="header">
          <div class="logo">
            <img
              src="@/assets/images/logo-lg.svg"
              class="unselectable mx-auto"
              alt
              width="20%"
            />
          </div>
          <p class="header-title">
            PASSPORT ACCOUNT
          </p>
          <span class="subtitle">Reset Password</span>
        </div>
        <form class="form" @submit.prevent="resetPassword">
          <!-- new password  -->
          <div class="new-password-wrapper">
            <div class="input-wrapper">
              <div class="form-group m-d-gruop mb-0" :class="{'invalid-field': submitted && $v.$invalid}">
                <b-form-input
                  :type="showPass ? 'text' : 'password'"
                  v-model="form.password"
                  required
                  @keyup="notMatched = false; submitted = false"
                />
                <label for="phone">Password</label>
              </div>
              <i class="mdi mdi-eye password-eye" @click="onShowPassword"></i>
            </div>
            <!-- <div class="err-wrapper">
              <div v-if="submitted && !$v.form.password.required">
                <span class="error-value">Current password is required</span>
              </div>
              <div v-else-if="submitted && !$v.form.password.minLength && $v.form.confirmPassword.sameAsPassword">
                <span class="error-value"
                  >Password should be at least 8 characters.</span
                >
              </div>
              <div v-else-if="submitted && !$v.form.password.maxLength && $v.form.confirmPassword.sameAsPassword">
                <span class="error-value"
                  >Password should be maximum 20 characters.</span
                >
              </div>
              <div v-else-if="submitted && !$v.form.password.containsUppercase && $v.form.confirmPassword.sameAsPassword">
                <span class="error-value"
                  >Password should have a uppercase letter.</span
                >
              </div>
              <div v-else-if="submitted && !$v.form.password.containsLowercase && $v.form.confirmPassword.sameAsPassword">
                <span class="error-value"
                  >Password should have a lowercase letter.</span
                >
              </div>
              <div v-else-if="submitted && !$v.form.password.containsNumber && $v.form.confirmPassword.sameAsPassword">
                <span class="error-value">Password should have a number.</span>
              </div>
              <div v-else-if="submitted && !$v.form.password.containsSpecial && $v.form.confirmPassword.sameAsPassword">
                <span class="error-value"
                  >Password should have a special character.</span
                >
              </div>
            </div> -->
          </div>
          <!-- confirm password   -->
          <div class="confirm-password-wrapper">
            <div class="input-wrapper">
              <div class="form-group m-d-gruop mb-0" :class="{'invalid-field': submitted && $v.$invalid}">
                <b-form-input
                  :type="showConfirmPass ? 'text' : 'password'"
                  v-model="form.confirmPassword"
                  required
                  @keyup="notMatched = false; submitted = false"
                />
                <label for="phone">Re-enter Password</label>
              </div>
              <i class="mdi mdi-eye password-eye" @click="onShowConfirmPassword"></i>
            </div>
            <div class="err-wrapper">
              <!-- <div v-if="submitted && !$v.form.confirmPassword.required">
                <span class="error-value">New password is required.</span>
              </div> -->
              <div
                v-if="submitted && notMatched && !$v.form.confirmPassword.sameAsPassword"
              >
                <span class="error-value">Passwords not matching, please check again</span>
              </div>
            </div>
          </div>
          <span class="text-hint password-hint" v-if="!notMatched" :class="{'invalid-text': submitted && $v.$invalid}">
            <strong v-if="!notMatched" :class="{'invalid-text': submitted && $v.$invalid}" class="bold-txt">Password must include:</strong> 8-20 characters, a lowercase letter, an
            uppercase letter, a number and a special character.
          </span>
          <div class="actions-wrapper">
            <b-button
              variant="primary"
              type="submit"
              :disabled="!disableBtn || notMatched || loadingSpinner"
              class="btn submit-btn"
            >
              <span>
                <i
                  v-if="loadingSpinner"
                  class="bx bx-loader bx-spin font-size-16 align-middle mr-2"
                ></i>
                <span v-else>Reset</span>
              </span>
            </b-button>
          </div>
          <div class="login-wrapper">
            <p class="login-title">Want to Login instead!</p>
            <router-link tag="a" to="/login" class="login-redirect"
              >{{ $t('common.login').toUpperCase()}}</router-link
            >
          </div>
        </form>
      </div>
    </section>
  </Layout>
</template>

<style lang="scss" scoped>
@media(max-width:992px){
  .wrapper{
    padding: 0px!important;
    .content{
      width: 360px!important;
      border-radius:0px!important;
      padding-right:26px!important;
      padding-left: 26px!important;
      .header {
        margin-top: 23px!important;
        margin-bottom: 114px!important;
        .logo{
          margin-right: auto;
          margin-left: auto;
          margin-bottom: 22px!important;
          img{
            width: 116px!important;
          height: 22px!important;
          
          }
        }
        .header-title{
          font-family: 'SF Pro Display'!important;
          font-style: normal!important;
          font-weight: 700!important;
          font-size: 16px!important;
          line-height: 19px!important;
          margin-bottom: 11px!important;

          text-align: center!important;

          color: #000000!important;
        }
        .subtitle{
          font-family: 'Lato'!important;
          font-style: normal!important;
          font-weight: 700!important;
          font-size: 14px!important;
          line-height: 17px!important;
          /* identical to box height */

          text-align: center!important;

          color: rgba(0, 0, 0, 0.28)!important;
        }
    }
    .text-hint {
        font-weight:500;
        font-size: 14px;
        color: #939393;
        line-height: 17px;
        opacity: 0.8;
        margin-bottom: 26px;
        .bold-txt{
          font-family: 'Lato';
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        /* or 121% */

        letter-spacing: 0.25px;

        /* #939393 */

        color: #939393;

        opacity: 0.8;
        }
      }
      .actions-wrapper{
        .submit-btn{
          width: 309px!important;
          height: 37px!important;
          font-family: 'Lato'!important;
            font-style: normal!important;
            font-weight: 500!important;
            font-size: 16px!important;
            line-height: 17px!important;
            border-radius: 18.5px!important;
            margin-top: 34px!important;
            margin-bottom: 30px!important;
            text-align: center;
            letter-spacing: 0.25px;
            text-transform: uppercase;
        }
      }
      .login-wrapper{
        margin-bottom: 147px!important;
        .login-title{
          font-family: 'Lato';
          font-style: normal;
          font-weight: 400!important;
          font-size: 13px!important;
          line-height: 20px!important;
          /* identical to box height, or 154% */

          letter-spacing: 0.25px;

          /* #666666 */
          margin-bottom:13px!important;
          color: #666666!important;

          mix-blend-mode: normal!important;
        }
        .login-redirect{
          font-family: 'Lato'!important;
            font-style: normal!important;
            font-weight: 700!important;
            font-size: 14px!important;
            line-height: 20px!important;
            /* identical to box height, or 143% */

            letter-spacing: 0.25px;

            /* Main Button */

            color: #103F5E;

            mix-blend-mode: normal;
        }
      }
      .err-wrapper{
        .error-value{
          font-family: 'Lato';
          font-style: normal;
          font-weight: 500;
          font-size: 12px;
          line-height: 19px;
          /* identical to box height, or 158% */

          letter-spacing: 0.25px;

          /* #F46A6A */

          color: #F46A6A;
        }
      }
    }
  }
}
.invalid-field {
  border: 1.5px solid #f46a6a!important;
}
.invalid-text {
  color: #f46a6a !important;
}
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  .content {
    width: 491px;
    border-radius: 26px;
    background-color: #fff;
    padding: 50px 40px;
    .header {
      text-align: center;
      margin-bottom: 65px;
      .logo {
        margin-bottom: 20px;
        margin-right: auto;
        margin-left: auto;
      }
      .header-title {
        font-weight: bold;
        font-size: 20px;
        text-align: center;
        color: #000000;
        margin-bottom: 9px;
      }
      .subtitle {
        font-weight: bold;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.28);
      }
    }
    .form {
      .new-password-wrapper{
      margin-bottom: 14px;
      }
      .confirm-password-wrapper{
        margin-bottom: 9px;
      }
      .input-wrapper {
        position: relative;
        .password-eye {
          color: #a4a4a4;
          font-size: 1.5rem;
          position: absolute;
          right: 25px;
          top: 13px;
          cursor: pointer;
        }
      }
      .text-hint {
        font-weight:400;
        font-size: 14px;
        color: #939393;
        line-height: 17px;
        opacity: 0.8;
        margin-bottom: 33px;
        .bold-txt{
          font-weight:700;
          color: #939393;

          opacity: 0.8;
        }
      }
      .actions-wrapper {
        .submit-btn {
          border-radius: 22px;
          height: 44px;
          text-transform: uppercase;
          color: rgba(255, 255, 255, 0.87);
          font-size: 16px;
          margin-top: 44px;
          margin-bottom: 33px;
          width: 100%;
        }
      }
      .login-wrapper {
        text-align: center;
        .login-title {
          color: rgba(0, 0, 0, 0.28);
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 22px;
        }
        .login-redirect {
          font-weight: bold;
          font-size: 16px;
          text-align: center;
          text-transform: uppercase;
          color: #103f5e;
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
